import { useMemo } from 'react'
import { FulfillmentType } from 'shop/types'
import { useConsumerCart, useQueryParams, useReactRouter } from 'shop/hooks'

/** Cart is a match if cart exists & the cart’s store matches the slug in the URL and cart's fulfilment type matches the fulfilment_type query parameter (if provided) */
export const useCartMatch = () => {
  const { cart } = useConsumerCart()
  const { getQueryParam } = useQueryParams()
  const { match } = useReactRouter<{ slug: string }>()

  const urlSlug = match.params.slug

  const fulfillmentTypeParam =
    (getQueryParam('fulfillment_type')?.toUpperCase() as FulfillmentType) ||
    undefined

  const isCartMatch = useMemo(() => {
    if (!cart || !cart.store || !cart.store.slug || !urlSlug) {
      return false
    }

    if (cart.store.slug !== urlSlug) {
      return false
    }

    if (fulfillmentTypeParam) {
      if (!cart.fulfillment || cart.fulfillment.type !== fulfillmentTypeParam) {
        return false
      }
    }

    return true
  }, [cart, urlSlug, fulfillmentTypeParam])

  return {
    isCartMatch
  }
}
